import { Box, TableCell, Tooltip } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { SortOn } from "routes/asset-register/plugins/regime-display/sort-on"

export function TypeReviewHeaderCell({ item: column }) {
    return (
        <TableCell
            align={column.align}
            sx={{ width: column.width, whiteSpace: "nowrap", ...column.sx }}
            data-cy={`type-review-header-${column.field}`}
        >
            <Box sx={{ display: "flex", justifyContent: column.align === "center" ? "center" : "flex-start" }}>
                <SortOn field={column.field}>
                    <If value={!!column.info}>
                        <Tooltip title={column.info ?? ""} arrow placement="top">
                            <Box component="span" data-cy={`type-review-header-label-${column.field}`}>
                                {column.label}
                            </Box>
                        </Tooltip>
                        <Else>{column.label}</Else>
                    </If>
                </SortOn>
            </Box>
        </TableCell>
    )
}
